module.exports = __webpack_public_path__ + "img/imp2.ed3176d0.png";